import { render, staticRenderFns } from "./DAvatar.vue?vue&type=template&id=32335c34&scoped=true&"
import script from "./DAvatar.vue?vue&type=script&lang=js&"
export * from "./DAvatar.vue?vue&type=script&lang=js&"
import style0 from "./DAvatar.vue?vue&type=style&index=0&id=32335c34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32335c34",
  null
  
)

export default component.exports